import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../../context/context";
import moment from "moment";
import DateRangePicker from "@wojtekmaj/react-daterange-picker/dist/DateRangePicker";

// import "./VolumeCovep.scss";
import { Button } from "@mui/material";
import LineChart from "../../../components/LineChart/LineChart";
import { getVolumeByUsuario } from "../../../services/graphics-service";
import { formatGraphicVolumePerUsuario } from "../../../utils/formatted-graphic-values";
import { getUsers } from "../../../services/user-service";
import SelectInput from "../../../components/Select/SelectInput";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
};

const VolumeUsuario = () => {
  const { sidebar } = useContext(Context);
  const accessToken = localStorage.getItem("token");
  const [graphicValues, setGraphicValues] = useState({});
  const [competitorList, setCompetitorList] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [showGraphic, setShowGraphic] = useState(false);
  const [dateValue, setDateValue] = useState([
    moment(new Date()).subtract(30, "day").toDate(),
    new Date(),
  ]);

  useEffect(() => {
    async function getUsersList() {
      const result = await getUsers(accessToken);

      if (!result) return;

      setCompetitorList(
        result.sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        )
      );
    }
    getUsersList();
  }, [accessToken]);

  const getGraphicData = async () => {
    const result = await getVolumeByUsuario(
      accessToken,
      dateValue[0],
      dateValue[1],
      selectedUser
    );
    setGraphicValues(formatGraphicVolumePerUsuario(result.data));
    console.log(formatGraphicVolumePerUsuario(result.data));
    setShowGraphic(true);
  };

  return (
    <main className={sidebar ? "container" : "container-full"}>
      <h1>Volume perdido por usuário</h1>

      <div className="graphic-csv-container">
        <p>Favor escolher um usuário para gerar o gráfico.</p>

        <DateRangePicker onChange={(e) => setDateValue(e)} value={dateValue} />
        {/* <div>
          <FormControl style={{ width: "272px" }}>
            <InputLabel id="demo-multiple-checkboxx-label">Usuários</InputLabel>
            <Select
              multiple
              value={selectedCompetitor}
              onChange={(e) => setSelectedCompetitor(e.target.value)}
              input={<OutlinedInput label="Concorrentes" />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={MenuProps}
            >
              {competitorList.map((item) => (
                <MenuItem key={`${item.name} - ${item.id}`} value={item.id}>
                  <Checkbox
                    checked={selectedCompetitor.indexOf(item.id) > -1}
                  />
                  <ListItemText primary={item.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div> */}

        <form className="form-container">
          <SelectInput
            value={selectedUser}
            name="Lista de Usuários"
            setValue={setSelectedUser}
            selectValues={competitorList}
          />
        </form>

        <Button
          className="generate-btn"
          variant="contained"
          onClick={getGraphicData}
        >
          Gerar gráfico
        </Button>
      </div>

      {showGraphic && (
        <>
          <h1>{`Total: ${graphicValues?.datasets?.[0]?.data?.reduce(
            (acc, el) => {
              return acc + el;
            },
            0
          )}`}</h1>
          <div className="graphic-container">
            <h1>{graphicValues.concorrente}</h1>
            <LineChart values={graphicValues} />
          </div>
        </>
      )}
    </main>
  );
};

export default VolumeUsuario;
